'use client'

import { AppState } from '@/lib/store'
import { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  Button,
  HttpService,
  Messages,
  ServiceEndpoints,
  SimpleReactValidator
} from '@/config/NextImport'
// import Swal from 'sweetalert2'

const ProductReviewForm = (props: any) => {
  const { userData } = useSelector((state: AppState) => state.user)
  const userLinkRef = useRef<any>(null)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const defaultInputs = {
    product_id: props.product_id !== undefined ? props.product_id : 0,
    name: '',
    email: '',
    title: '',
    review: '',
    rating: 0,
    customer_id: 0
  }
  const [Inputs, setInputs] = useState(defaultInputs)
  const Validator = useRef(new SimpleReactValidator())
  const changeRating = (rating: any) => {
    Inputs.rating = rating
    setForceUpdate(!isForceUpdate)
  }

  const showLoginModal = () => {
    userLinkRef.current.click()
  }
  const submitReview = async () => {
    if (!Validator.current.allValid()) {
      Validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    } else {
      Validator.current.hideMessages()
      setForceUpdate(!isForceUpdate)
    }
    if (userData.user == null) {
      showLoginModal()
      return
    }
    const param = {
      _id: 0,
      _title: Inputs.title,
      _review: Inputs.review,
      _rating: Inputs.rating,
      _product_id: props.product_id.parent_product_id,
      _name: userData.user.firstname + ' ' + userData.user.lastname,
      _email: userData.user.email,
      _customer_id: userData.user.id,
      _status: 0
    }
    const response = await HttpService.postApi(ServiceEndpoints.WriteProductReview, param)
    if (response.status) {
      setInputs(defaultInputs)
      setForceUpdate(!isForceUpdate)
      const Swal = (await import('sweetalert2')).default
      Swal.fire({
        title: Messages.Thankyou,
        text: Messages.ReviewSubmitted,
        icon: 'success'
      })
    }
  }
  const revtitleRef = useRef<any>(null)
  const onToggleClick = () => {
    revtitleRef.current.classList.toggle('active')
  }

  return (
    <>
      {userData.user !== null && userData.user !== undefined && (
        <div
          className="col-md-12 col-lg-6 write-review-form"
          id="reviews"
        >
          <div className="col-lg-12 col-md-12 write-review-title">
            <h2
              onClick={onToggleClick}
              ref={revtitleRef}
            >
              We appreciate your feedback
            </h2>
          </div>
          <div className="col-lg-12 col-md-12">
            <form
              id="frm-review"
              className="forms-sample"
              autoComplete="off"
            >
              <div className="form-group">
                <label>How much do you like design and style of this product?</label>
                <div className="write-review-icon">
                  <div className="form-group rating-label my-3">
                    {[...Array(11)].map(
                      (x, i) =>
                        i !== 0 && (
                          <label
                            key={i}
                            htmlFor={String(i)}
                            className={i === Inputs.rating ? 'me-3 cursor active' : 'me-3 cursor'}
                            defaultValue={Inputs.rating}
                            onClick={() => changeRating(i)}
                          >
                            {i}
                          </label>
                        )
                    )}
                  </div>
                </div>
              </div>
              {/* <div className="form-group">
                        <label htmlFor="txtTitle">Title</label>
                        <input type="text" className="form-control" name='title' id="txtTitle" onChange={handleInputChange} value={Inputs.title} />
                        {ReviewValidator.current.message('Title', Inputs.title, 'required|max:255', { className: 'error' })}
                    </div>
                    <div className="form-group">
                        <label htmlFor="txtReview">Review</label>
                        <textarea name="review" className='form-control' id="txtReview" rows={3} onChange={handleInputChange} value={Inputs.review}></textarea>
                        {ReviewValidator.current.message('Review', Inputs.review, 'required|max:1000', { className: 'error' })}
                    </div> */}

              {/* <div className="row">
                        <div className="form-group col-md-6">
                            <label htmlFor="txtName">Name</label>
                            <input type="text" className="form-control" id="txtName" name="name" onChange={handleInputChange} value={Inputs.name} />
                            {ReviewValidator.current.message('Name', Inputs.name, 'required|max:255', { className: 'error' })}
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="txtEmail">Email</label>
                            <input type="text" className="form-control" id="txtEmail" name="email" onChange={handleInputChange} value={Inputs.email} />
                            {ReviewValidator.current.message('Email', Inputs.email, 'email', { className: 'error' })}
                        </div>
                    </div> */}
              <a
                hidden
                data-bs-toggle="modal"
                data-bs-target="#LoginModal"
                className="custom-color cursor"
                ref={userLinkRef}
              ></a>
              <Button
                variant="primary"
                className="btn btn-custom mr-2"
                onClick={submitReview}
              >
                {' '}
                Submit{' '}
              </Button>
            </form>
          </div>
        </div>
      )}
    </>
  )
}

export default ProductReviewForm
